import { render } from "./pcDialog.vue?vue&type=template&id=4a476b55&scoped=true"
import script from "./pcDialog.vue?vue&type=script&lang=js"
export * from "./pcDialog.vue?vue&type=script&lang=js"

import "./pcDialog.vue?vue&type=style&index=0&id=4a476b55&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a476b55"]])

export default __exports__